<div class="container-custom mt-3">
  <app-navigator id="event-navigator-component" [parentLabel]="'Event'"></app-navigator>
  <app-event-form-info id="event-form-info-component" (saveSuccess)="onSubmit()"></app-event-form-info>
</div>